import Button from '@components/Button'
import { CardSection } from '@components/CardSection'
import styles from './styles.module.scss'

const LoginSignUpContainerMobile = ({ onClickLogin, guestCheckoutBtnHandler }) => (
    <CardSection className={styles.loginContainerTextSectionMobileView}>
        <div className={styles.guestCheckoutRegisteredSection}>
            <p className="text-large">
                <span className="font-weight-bold">
                    <T>guest.booking.checkout.login.section.label.part1</T>{' '}
                </span>
                <T>guest.booking.checkout.login.section.label.part2</T>
            </p>
            <Button
                btnStyle="outline"
                className={styles.guestCheckoutBaseBtn}
                onClick={() => {
                    onClickLogin()
                }}>
                <T>guest.booking.checkout.login.btn.label</T>
            </Button>
        </div>
        <div className={styles.guestCheckoutNotRegisteredSection}>
            <p className="text-large">
                <span className="font-weight-bold">
                    <T>guest.booking.checkout.not.registered.section.label.part1</T>{' '}
                </span>
                <T>guest.booking.checkout.not.registered.section.label.part2</T>
            </p>
            <Button className={styles.guestCheckoutBaseBtn} onClick={guestCheckoutBtnHandler}>
                <T>guest.booking.checkout.btn.label</T>
            </Button>
        </div>
    </CardSection>
)

export default LoginSignUpContainerMobile
